var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-block-bg"},[_c('div',{staticClass:"user p-25 pb-0"},[_c('transition',{attrs:{"appear":"","name":"slideAvatar"}},[_c('div',{staticClass:"d-flex align-items-center justify-content-center",staticStyle:{"gap":"10px"}},[_c('div',{staticClass:"user-info"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.store))])]),_c('img',{staticClass:"avatar",style:({
                border: 'none',
                objectFit: 'contain',
                background: 'none'
              }),attrs:{"src":_vm._f("photo")(_vm.logo),"alt":""}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }